import React from "react";
import { Link } from "react-router-dom";
import "./About.scss";

const About = () => (
    <section id="about" className="section-wrapper" aria-labelledby="about-title">
        <div className="section-inner">
            <h1 id="about-title" className="section-title">About</h1>
            <p>I’m a full-stack developer with a UX/UI twist—part problem solver, part designer, fully obsessed with building digital experiences people actually enjoy using. I get the same joy from fixing a bug as I do from crafting a smooth user flow, and I love combining both sides of my brain to create something functional and beautiful.</p>
            <p>I’m all about understanding how users think, what they feel, and what they need. If I can make someone’s day even a little easier with good design, that’s a win.</p>
            <div className="btn-group">
                <Link to="/projects" className="btn btn-secondary">
                    See my work
                </Link>
                <Link to="/contact" className="btn btn-primary">
                    Get in touch
                </Link>
            </div>
        </div>
    </section>
)

export default About;